import { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import styled, { keyframes } from 'styled-components';
import emailjs from 'emailjs-com';
import { Button, Form, Container } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { 
  AiFillGithub, 
  AiFillInstagram, 
  AiOutlineSend,
  AiOutlineCheckCircle,
  AiOutlineMail
} from "react-icons/ai";
import { 
  FaLinkedinIn, 
  FaWhatsapp, 
  FaPhone, 
  FaEnvelope,
  FaPaperPlane,
  FaComment
} from "react-icons/fa";
import { FiMessageSquare, FiUser } from "react-icons/fi";
import LivePreviewButton from '../livePreview';
import { FaVideo } from "react-icons/fa";

// Animations
const float = keyframes`
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
`;

const shimmer = keyframes`
  0% { background-position: -200% center; }
  100% { background-position: 200% center; }
`;

const ContactWrapper = styled.div`
  position: relative;
  // min-height: 100vh;
  // overflow: hidden;

  .contact-section {
    position: relative;
    padding: 80px 20px !important;
    color: white;
    z-index: 1;
  }

  .contact-content {
    max-width: 1200px;
    margin: 0 auto;
  }

  .section-title {
    text-align: center;
    margin-bottom: 60px;
    position: relative;

    h2 {
      font-size: 3.5em;
      font-weight: 800;
      margin-bottom: 15px;
      background: linear-gradient(45deg, var(--primary-color), var(--secondary-color), #fff);
      background-size: 200% auto;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      animation: ${shimmer} 3s ease infinite;
      
      @media (max-width: 768px) {
        font-size: 2.5em;
      }
    }

    .title-sub {
      font-size: 1.1em;
      color: var(--text-secondary);
      max-width: 600px;
      margin: 0 auto;
      line-height: 1.6;
    }

    &::after {
      content: '';
      position: absolute;
      bottom: -20px;
      left: 50%;
      transform: translateX(-50%);
      width: 100px;
      height: 4px;
      background: linear-gradient(90deg, var(--primary-color), var(--secondary-color));
      border-radius: 2px;
    }
  }

  .contact-grid {
    display: grid;
    grid-template-columns: 1fr 1.2fr;
    gap: 40px;
    
    
    @media (max-width: 992px) {
      grid-template-columns: 1fr;
      gap: 30px;
    }
  }
`;

const ContactInfoCard = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(
    135deg,
    rgba(199, 112, 240, 0.05),
    rgba(205, 95, 248, 0.02)
  );
  border: 1px solid var(--card-border);
  border-radius: 20px;
  padding: 40px;
  backdrop-filter: blur(20px);
  box-shadow: 
    0 20px 40px rgba(0, 0, 0, 0.2),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
  height: 100%;
  position: relative;
  transition: all 0.4s ease;

  &:hover {
    transform: translateY(-5px);
    border-color: rgba(199, 112, 240, 0.3);
    box-shadow: 
      0 25px 50px rgba(0, 0, 0, 0.3),
      inset 0 1px 0 rgba(255, 255, 255, 0.2);
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(199, 112, 240, 0.5),
      transparent
    );
  }

  .info-header {
    margin-bottom: 40px;

    h3 {
      font-size: 1.8em;
      font-weight: 700;
      margin-bottom: 10px;
      color: var(--text-primary);
      display: flex;
      align-items: center;
      gap: 10px;

      .header-icon {
        color: var(--primary-color);
        animation: ${float} 3s ease-in-out infinite;
      }
    }

    p {
      color: var(--text-secondary);
      line-height: 1.6;
      margin: 0;
    }
  }
`;

const InfoItem = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 30px;
  padding: 15px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid var(--card-border);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;

  &:hover {
    background: rgba(199, 112, 240, 0.05);
    border-color: rgba(199, 112, 240, 0.2);
    transform: translateX(5px);

    .item-icon {
      // background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));
      transform: scale(1.1);
    }
  }

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 3px;
    background: linear-gradient(to bottom, var(--primary-color), var(--secondary-color));
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover::before {
    opacity: 1;
  }

  .item-icon {
    width: 50px;
    height: 50px;
    min-width: 50px;
    background: rgba(199, 112, 240, 0.1);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 20px;
    color: var(--primary-color);
    font-size: 1.3em;
    transition: all 0.3s ease;
  }

  .item-content {
    flex: 1;

    h4 {
      font-size: 1.1em;
      font-weight: 600;
      margin-bottom: 5px;
      color: var(--text-primary);
      text-align: start;
    }

    p, a {
      color: var(--text-secondary);
      text-decoration: none;
      transition: color 0.3s ease;
      margin: 0;
      line-height: 1.6;
      display: block;
      text-align: start !important;

    }

    a:hover {
      color: var(--primary-color);
    }
  }
`;

const SocialLinks = styled.div`
  margin-top: 40px;
  padding-top: 30px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);

  h4 {
    font-size: 1.2em;
    font-weight: 600;
    margin-bottom: 20px;
    color: var(--text-primary);
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .social-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 15px;

    @media (max-width: 576px) {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  .social-icon {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 15px;
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid var(--card-border);
    border-radius: 12px;
    text-decoration: none;
    color: var(--text-secondary);
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;

    &:hover {
      background: rgba(199, 112, 240, 0.1);
      border-color: var(--primary-color);
      transform: translateY(-5px);
      color: var(--primary-color);

      .icon-wrapper {
        transform: scale(1.1);
      }

      .social-label {
        color: var(--primary-color);
      }
    }

    .icon-wrapper {
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1.5em;
      margin-bottom: 10px;
      transition: all 0.3s ease;
    }

    .social-label {
      font-size: 0.85em;
      font-weight: 500;
      transition: all 0.3s ease;
    }
  }
`;

const ContactFormCard = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.05),
    rgba(255, 255, 255, 0.02)
  );
  border: 1px solid var(--card-border);
  border-radius: 20px;
  padding: 40px;
  backdrop-filter: blur(20px);
  box-shadow: 
    0 20px 40px rgba(0, 0, 0, 0.2),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
  transition: all 0.4s ease;

  &:hover {
    border-color: rgba(199, 112, 240, 0.3);
    box-shadow: 
      0 25px 50px rgba(0, 0, 0, 0.3),
      inset 0 1px 0 rgba(255, 255, 255, 0.2);
  }

  .form-header {
    margin-bottom: 30px;

    h3 {
      font-size: 1.8em;
      font-weight: 700;
      margin-bottom: 10px;
      color: var(--text-primary);
      display: flex;
      align-items: center;
      gap: 10px;

      .form-icon {
        color: var(--primary-color);
      }
    }

    p {
      color: var(--text-secondary);
      line-height: 1.6;
      margin: 0;
    }
  }
`;

const FormGroup = styled.div`
  margin-bottom: 25px;
  position: relative;

  .form-label {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.95em;
    font-weight: 500;
    color: var(--text-primary);
    margin-bottom: 8px;

    .label-icon {
      color: var(--primary-color);
      font-size: 1.1em;
    }
  }

  .form-input-wrapper {
    position: relative;
  }

  .form-input {
    width: 100%;
    padding: 16px 20px 16px 50px;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid var(--card-border);
    border-radius: 12px;
    color: var(--text-primary);
    font-size: 1em;
    transition: all 0.3s ease;
    outline: none;

    &::placeholder {
      color: var(--text-secondary);
      opacity: 0.6;
    }

    &:focus {
      background: rgba(255, 255, 255, 0.08);
      border-color: var(--primary-color);
      box-shadow: 0 0 0 3px rgba(199, 112, 240, 0.2);
    }

    &:hover:not(:focus) {
      border-color: rgba(255, 255, 255, 0.2);
    }
  }

  .input-icon {
    position: absolute;
    left: 18px;
    top: 50%;
    transform: translateY(-50%);
    color: var(--text-secondary);
    font-size: 1.2em;
    transition: all 0.3s ease;
  }

  .form-input:focus + .input-icon {
    color: var(--primary-color);
  }

  .form-textarea {
    min-height: 150px;
    resize: vertical;
  }

  .char-count {
    position: absolute;
    right: 15px;
    bottom: 15px;
    font-size: 0.85em;
    color: ${props => props.messageLength >= 10 ? '#4ade80' : '#f87171'};
    opacity: 0.7;
  }
`;

const SubmitButton = styled(Button)`
  width: 100%;

`;



const Contact = () => {
  const [formValues, setFormValues] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [validated, setValidated] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [charCount, setCharCount] = useState(0);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
    
    if (name === 'message') {
      setCharCount(value.length);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }

    if (formValues.message.length < 10) {
      Swal.fire({
        icon: 'warning',
        title: 'Message Too Short',
        text: 'Please provide a message with at least 10 characters.',
        confirmButtonColor: 'var(--primary-color)',
        background: 'var(--bg)',
        color: 'var(--text-primary)',
      });
      return;
    }

    const templateParams = {
      from_name: formValues.name,
      from_email: formValues.email,
      subject: formValues.subject || 'No Subject',
      message: formValues.message,
      to_email: 'ali.portfolioservices@gmail.com',
    };

    try {
      setIsSending(true);
      await emailjs.send(
        'service_wzx16se',
        'template_zclky9f',
        templateParams,
        'fn37Sw_5Jc4MRqYy7'
      );

      Swal.fire({
        icon: 'success',
        title: 'Message Sent Successfully!',
        html: 'Your message has been sent.<br>I\'ll get back to you soon!',
        confirmButtonColor: 'var(--primary-color)',
        background: 'var(--bg)',
        color: 'var(--text-primary)',
        confirmButtonText: 'Awesome!',
        showConfirmButton: true,
        timer: 3000
      });
      
      setFormValues({ name: '', email: '', subject: '', message: '' });
      setCharCount(0);
      setValidated(false);
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Failed to send the message. Please try again later.',
        confirmButtonColor: '#d33',
        background: 'var(--bg)',
        color: 'var(--text-primary)',
        confirmButtonText: 'Try Again'
      });
    } finally {
      setIsSending(false);
    }
  };

  return (
    <ContactWrapper>
      <Container fluid className="contact-section">

        <Container className="contact-content">
          <div className="section-title">
            <h2>Let's Connect</h2>
            <p className="title-sub">
              Have a project in mind or want to discuss opportunities? 
              Feel free to reach out. I'm always open to new collaborations and conversations.
            </p>
          </div>

          <div className="contact-grid">
            {/* Left Column - Contact Information */}
            <div>
              <ContactInfoCard>
                <div className="info-header">
                  <h3>
                    <AiOutlineMail className="header-icon" />
                    Contact Information
                  </h3>
                  {/* <p>
                    Feel free to reach out through any of these channels. 
                    I typically respond within 24 hours.
                  </p> */}
                </div>

                <InfoItem>
                  <div className="item-icon">
                    <FaEnvelope />
                  </div>
                  <div className="item-content">
                    <h4>Email Address</h4>
                    <a href="mailto:m13ali1000@gmail.com">
                      m13ali1000@gmail.com
                    </a>
                  </div>
                </InfoItem>

                <InfoItem>
                  <div className="item-icon">
                    <FaPhone />
                  </div>
                  <div className="item-content">
                    <h4>Phone Number</h4>
                    <a href="tel:+923083653441">
                      +92 308 3653 441
                    </a>
                  </div>
                </InfoItem>

                <InfoItem>
                  <div className="item-icon">
                    <FaVideo />
                  </div>
                  <div className="item-content">
                    <h4>Quick meeting</h4>
                        <LivePreviewButton
                        url="https://cal.com/m.ali"
                        innerText="Book Meeting"
                        
                      />
                    
                  </div>
                </InfoItem>

                <InfoItem>
                  <div className="item-icon">
                    <FaWhatsapp />
                  </div>
                  <div className="item-content">
                    <h4>WhatsApp</h4>
                    <a href="https://wa.me/+923083653441" target="_blank" rel="noreferrer">
                      Send me a message on WhatsApp
                    </a>
                  </div>
                </InfoItem>

                <SocialLinks>
                  <div className="social-grid">
                    <a href="https://github.com/Mali5341" target="_blank" rel="noopener noreferrer" className="social-icon">
                      <div className="icon-wrapper">
                        <AiFillGithub />
                      </div>
                      <span className="social-label">GitHub</span>
                    </a>
                    <a href="https://wa.me/+923083653441" target="_blank" rel="noreferrer" className="social-icon">
                      <div className="icon-wrapper">
                        <FaWhatsapp />
                      </div>
                      <span className="social-label">WhatsApp</span>
                    </a>
                    <a href="https://www.linkedin.com/in/m-ali-4816412bb/" target="_blank" rel="noopener noreferrer" className="social-icon">
                      <div className="icon-wrapper">
                        <FaLinkedinIn />
                      </div>
                      <span className="social-label">LinkedIn</span>
                    </a>
                    <a href="https://www.instagram.com/mali4_41/" target="_blank" rel="noopener noreferrer" className="social-icon">
                      <div className="icon-wrapper">
                        <AiFillInstagram />
                      </div>
                      <span className="social-label">Instagram</span>
                    </a>
                  </div>
                </SocialLinks>
              </ContactInfoCard>
            </div>

            {/* Right Column - Contact Form */}
            <div>
              <ContactFormCard>
                <div className="form-header">
                  <h3>
                    <FaPaperPlane className="form-icon" />
                    Send a Message
                  </h3>
                  {/* <p>
                    Fill out the form below and I'll get back to you as soon as possible. 
                    All fields are required unless marked optional.
                  </p> */}
                </div>

                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                  <FormGroup>
                    <label className="form-label">
                      <FiUser className="label-icon" />
                      Your Full Name
                    </label>
                    <div className="form-input-wrapper">
                      <input
                        className="form-input"
                        required
                        type="text"
                        placeholder="Enter your full name"
                        name="name"
                        value={formValues.name}
                        onChange={handleInputChange}
                      />
                      <FiUser className="input-icon" />
                    </div>
                  </FormGroup>

                  <FormGroup>
                    <label className="form-label">
                      <AiOutlineMail className="label-icon" />
                      Email Address
                    </label>
                    <div className="form-input-wrapper">
                      <input
                        className="form-input"
                        required
                        type="email"
                        placeholder="you@example.com"
                        name="email"
                        value={formValues.email}
                        onChange={handleInputChange}
                      />
                      <AiOutlineMail className="input-icon" />
                    </div>
                  </FormGroup>

                  <FormGroup>
                    <label className="form-label">
                      <FaComment className="label-icon" />
                      Subject (Optional)
                    </label>
                    <div className="form-input-wrapper">
                      <input
                        className="form-input"
                        type="text"
                        placeholder="What is this regarding?"
                        name="subject"
                        value={formValues.subject}
                        onChange={handleInputChange}
                      />
                      <FaComment className="input-icon" />
                    </div>
                  </FormGroup>

                  <FormGroup messageLength={charCount}>
                    <label className="form-label">
                      <FiMessageSquare className="label-icon" />
                      Your Message
                    </label>
                    <div className="form-input-wrapper">
                      <textarea
                        className="form-input form-textarea"
                        required
                        placeholder="Tell me about your project, idea, or question..."
                        name="message"
                        value={formValues.message}
                        onChange={handleInputChange}
                        minLength="10"
                      />
                      <div className="char-count">
                        {charCount}/10 min
                      </div>
                    </div>
                  </FormGroup>

                  <SubmitButton type="submit" disabled={isSending}>
                    <div className="button-text">
                      {isSending ? (
                        <>
                          <span>Sending...</span>
                          <AiOutlineCheckCircle />
                        </>
                      ) : (
                        <>
                          <span>Send Message</span>
                          <AiOutlineSend />
                        </>
                      )}
                    </div>
                  </SubmitButton>
                </Form>
              </ContactFormCard>
            </div>
          </div>
        </Container>
      </Container>
    </ContactWrapper>
  );
};

export default Contact;